// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Vrb4m","inner":"styles_inner__zJKZX"};